<template>
    <div>
        <!--Edit Staff Dialog-->
        <Dialog :visible.sync="staffDialog" :style="{width: '450px'}" header="Staff Details" :modal="true"
                :maximizable="true"
                class="p-fluid">

            <div class="p-field">
                <label for="team">Team</label>
                <Dropdown id="team" v-model="staff.team"
                          :options="teams" optionLabel="name" placeholder="Select a Team"
                          :class="{'p-invalid': submitted && $v.staff.team.$invalid}">
                    <template #value="slotProps">
                        <div class="country-item country-item-value" v-if="slotProps.value">
                            <div style="margin-left: 20px">{{slotProps.value.name}}</div>
                        </div>
                        <div class="country-item country-item-value" v-else>
                            <div style="margin-left: 20px">{{slotProps.placeholder}}</div>
                        </div>
                    </template>
                </Dropdown>
                <small class="p-invalid" v-if="submitted && $v.staff.team.$invalid">Team is
                    required.</small>
            </div>

            <div class="p-field">
                <label for="name">Name</label>
                <InputText id="name" v-model.trim="staff.name" required="true" autofocus
                           :class="{'p-invalid': submitted && $v.staff.name.$invalid}"/>
                <small class="p-invalid" v-if="submitted && $v.staff.name.$invalid">Name is required.</small>
            </div>

            <div class="p-field">
                <label for="email">Email</label>
                <InputText id="email" v-model.trim="staff.email" required="true" autofocus
                           :class="{'p-invalid': submitted && $v.staff.email.$invalid}"/>
                <small class="p-invalid" v-if="submitted && !$v.staff.email.required">Email is required.</small>
                <small class="p-invalid" v-if="submitted && !$v.staff.email.email">Invalid email format.</small>
            </div>

            <div class="p-field">
                <label for="job-title">Job Title</label>
                <InputText id="job-title" v-model.trim="staff['job-title']" required="true" autofocus
                           :class="{'p-invalid': submitted && $v.staff['job-title'].$invalid}"/>
                <small class="p-invalid" v-if="submitted && $v.staff['job-title'].$invalid">Job Title is
                    required.</small>
            </div>

            <div>
                <!--            <div class="p-field" v-if="!staff.academics">-->
                <!--                <label>Academics</label>-->
                <!--                <span class="p-fluid">-->
                <!--                    <AutoComplete :multiple="true"-->
                <!--                                  v-model="selectedAcademics"-->
                <!--                                  :suggestions="filteredAcademics"-->
                <!--                                  @complete="searchAcademic($event)"-->
                <!--                                  :dropdown="true"-->
                <!--                                  field="title"-->
                <!--                                  placeholder="Search for Academics"-->
                <!--                                  style="margin: 1em">-->
                <!--                    <template #item="slotProps">-->
                <!--                        <div class="country-item">-->
                <!--                            <div>{{slotProps.item.title}}</div>-->
                <!--                        </div>-->
                <!--                    </template>-->
                <!--                </AutoComplete>-->
                <!--                </span>-->
                <!--            </div>-->

                <!--            <div class="p-field" v-if="!staff.professionals">-->
                <!--                <label>Professionals</label>-->
                <!--                <span class="p-fluid">-->
                <!--                    <AutoComplete :multiple="true"-->
                <!--                                  v-model="selectedProfessionals"-->
                <!--                                  :suggestions="filteredProfessionals"-->
                <!--                                  @complete="searchProfessional($event)"-->
                <!--                                  :dropdown="true"-->
                <!--                                  field="title"-->
                <!--                                  placeholder="Search for Professionals"-->
                <!--                                  style="margin: 1em">-->
                <!--                    <template #item="slotProps">-->
                <!--                        <div class="country-item">-->
                <!--                            <div>{{slotProps.item.title}}</div>-->
                <!--                        </div>-->
                <!--                    </template>-->
                <!--                </AutoComplete>-->
                <!--                </span>-->
                <!--            </div>-->

                <!--            <div class="p-field" v-if="!staff.trainings">-->
                <!--                <label>Trainings</label>-->
                <!--                <span class="p-fluid">-->
                <!--                    <AutoComplete :multiple="true"-->
                <!--                                  v-model="selectedTrainings"-->
                <!--                                  :suggestions="filteredTrainings"-->
                <!--                                  @complete="searchTraining($event)"-->
                <!--                                  :dropdown="true"-->
                <!--                                  field="name"-->
                <!--                                  placeholder="Search for Trainings"-->
                <!--                                  style="margin: 1em">-->
                <!--                    <template #item="slotProps">-->
                <!--                        <div class="country-item">-->
                <!--                            <div>{{slotProps.item.name}}</div>-->
                <!--                        </div>-->
                <!--                    </template>-->
                <!--                </AutoComplete>-->
                <!--                </span>-->
                <!--            </div>-->

            </div>

            <template #footer>
                <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
                <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveStaff"/>
            </template>
        </Dialog>

        <!--Delete Staff Dialog-->
        <Dialog :visible.sync="deleteStaffDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
                <span v-if="staff">Are you sure you want to delete <b>{{staff.name}}</b>?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text"
                        @click="deleteStaffDialog = false"/>
                <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteStaff"/>
            </template>
        </Dialog>

        <!--Delete Staffs Dialog-->
        <Dialog :visible.sync="deleteStaffsDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
                <span v-if="staff">Are you sure you want to delete the selected staff?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text"
                        @click="deleteStaffsDialog = false"/>
                <Button label="Yes" icon="pi pi-check" class="p-button-text"
                        @click="deleteSelectedStaffs"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
    import {Component, Prop, Vue} from "vue-property-decorator";

    Component.registerHooks(['validations']);
    import {required, email} from 'vuelidate/lib/validators'
    import Toast from 'primevue/toast';
    import Dialog from "primevue/dialog";
    import Dropdown from 'primevue/dropdown';
    import InputText from 'primevue/inputtext';
    import Button from 'primevue/button';
    import AutoComplete from 'primevue/autocomplete';
    import TeamService from "@/service/TeamService";
    import StaffService from "@/service/StaffService";
    import InputSwitch from 'primevue/inputswitch';

    /**
     * Class-component
     */
    @Component({
        components: {
            Toast: Vue.extend(Toast),
            Dialog: Vue.extend(Dialog),
            Dropdown: Vue.extend(Dropdown),
            InputText: Vue.extend(InputText),
            Button: Vue.extend(Button),
            AutoComplete: Vue.extend(AutoComplete),
            InputSwitch: Vue.extend(InputSwitch),
        }
    })
    export default class StaffDialog extends Vue {
        teamService = new TeamService();
        teams = [];
        staffService = new StaffService();
        staffDialog = false;
        deleteStaffDialog = false;
        deleteStaffsDialog = false;
        staff = {};
        submitted = false;
        selectedStaffs = [];
        // academicId = null;
        // academicService = new AcademicService();
        // academics = [];
        // selectedAcademics = [];
        // filteredAcademics = [];
        // professionalService = new ProfessionalService();
        // professionals = [];
        // selectedProfessionals = [];
        // filteredProfessionals = [];
        // trainingService = new TrainingService();
        // trainings = [];
        // selectedTrainings = [];
        // filteredTrainings = [];
        // checked = false;
        // showToggle = true;

        toastSuccess = {
            severity: 'success',
            summary: 'Successful',
            detail: '',
            life: 3000
        };
        toastError = {
            severity: 'error',
            summary: 'Error',
            detail: '',
            life: 3000
        };

        validations() {
            return {
                staff: {
                    team: {required},
                    name: {required},
                    email: {required, email},
                    'job-title': {required}
                }
            }
        }

        async mounted() {
            try {
                this.teams = await this.teamService.getTeams();
                // this.staffs = await this.staffService.getStaffs();
                // this.academics = await this.academicService.getAcademics();
                // this.professionals = await this.professionalService.getProfessionals();
                // this.trainings = await this.trainingService.getTrainings();
            } catch (e) {
                this.toastError.detail = e.message
                this.$toast.add(this.toastError);
                this.staffService.logError(e).forEach(err => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Details',
                        detail: err,
                    });
                })
            }
        }

        hideDialog() {
            this.staffDialog = false;
            this.submitted = false;
        }

        async saveStaff() {
            this.submitted = true;

            if (this.$v.$invalid) {
                return; // invalid input
            }

            const staffObj = {
                _jv: {
                    type: 'staffs',
                    relationships: {
                        team: {data: {id: this.staff.team._jv.id, type: 'teams'}}
                    }
                }
            };

            ['name', 'email', 'job-title'].forEach(el => {
                staffObj[el] = this.staff[el]
            });

            try {
                if (this.staff._jv) {
                    // PATCH
                    staffObj._jv.id = this.staff._jv.id
                    await this.staffService.updateStaff(staffObj)
                } else {
                    // POST
                    await this.staffService.createStaff(staffObj);

                    // const createdStaff = await this.staffService.createStaff(staffObj);
                    // if (this.showToggle && this.academicId) {
                    //     // linkage to academic / cert / training
                    //     await this.academicService.createRelationship(this.academicId, 'staffs', [
                    //         {"type": "staffs", "id": `${createdStaff._jv.id}`}
                    //     ])
                    // }

                    // // create academics
                    // if (this.selectedAcademics.length) {
                    //     const relArr = []
                    //     this.selectedAcademics.forEach(academic => {
                    //         relArr.push({"type": "academics", "id": `${academic._jv.id}`})
                    //     })
                    //     await this.staffService.createRelationship(createdStaff._jv.id, 'academics', relArr)
                    // }
                    //
                    // // create professionals
                    // if (this.selectedProfessionals.length) {
                    //     const relArr = []
                    //     this.selectedProfessionals.forEach(professional => {
                    //         relArr.push({"type": "professionals", "id": `${professional._jv.id}`})
                    //     })
                    //     await this.staffService.createRelationship(createdStaff._jv.id, 'professionals', relArr)
                    // }
                    //
                    // // create trainings
                    // if (this.selectedTrainings.length) {
                    //     const relArr = []
                    //     this.selectedTrainings.forEach(training => {
                    //         relArr.push({"type": "trainings", "id": `${training._jv.id}`})
                    //     })
                    //     await this.staffService.createRelationship(createdStaff._jv.id, 'trainings', relArr)
                    // }

                }

                this.$emit('updated')
                this.toastSuccess.detail = 'Staff Updated'
                this.$toast.add(this.toastSuccess);
            } catch (e) {
                this.toastError.detail = e.message
                this.$toast.add(this.toastError);
                this.staffService.logError(e).forEach(err => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Details',
                        detail: err,
                    });
                })
            }

            this.staffDialog = false;
            this.staff = {};
        }

        async deleteStaff() {
            try {
                await this.staffService.deleteStaff(this.staff._jv.id)
                this.$emit('updated')
                this.toastSuccess.detail = 'Staff Deleted'
                this.$toast.add(this.toastSuccess);
            } catch (e) {
                this.toastError.detail = e.message
                this.$toast.add(this.toastError);
                this.staffService.logError(e).forEach(err => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Details',
                        detail: err,
                    });
                })
            }

            this.deleteStaffDialog = false;
            this.staff = {};
        }

        async deleteSelectedStaffs() {
            try {
                for (const deleteStaff of this.selectedStaffs) {
                    await this.staffService.deleteStaff(deleteStaff._jv.id)
                }
                this.$emit('updated')
                this.toastSuccess.detail = 'Staffs Deleted'
                this.$toast.add(this.toastSuccess);
            } catch (e) {
                this.toastError.detail = e.message
                this.$toast.add(this.toastError);
                this.staffService.logError(e).forEach(err => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Details',
                        detail: err,
                    });
                })
            }

            this.deleteStaffsDialog = false;
            this.selectedStaffs = null;
        }

        // searchAcademic(event) {
        //     setTimeout(() => {
        //         if (!event.query.trim().length) {
        //             this.filteredAcademics = [...this.academics];
        //         } else {
        //             this.filteredAcademics = this.academics.filter((academic) => {
        //                 return academic.title.toLowerCase().includes(event.query.toLowerCase());
        //             });
        //         }
        //     }, 200);
        // }
        //
        // searchProfessional(event) {
        //     setTimeout(() => {
        //         if (!event.query.trim().length) {
        //             this.filteredProfessionals = [...this.professionals];
        //         } else {
        //             this.filteredProfessionals = this.professionals.filter((professional) => {
        //                 return professional.title.toLowerCase().includes(event.query.toLowerCase());
        //             });
        //         }
        //     }, 200);
        // }
        //
        // searchTraining(event) {
        //     setTimeout(() => {
        //         if (!event.query.trim().length) {
        //             this.filteredTrainings = [...this.trainings];
        //         } else {
        //             this.filteredTrainings = this.trainings.filter((training) => {
        //                 return training.name.toLowerCase().includes(event.query.toLowerCase());
        //             });
        //         }
        //     }, 200);
        // }


    }


</script>

<style scoped>

</style>